function addToCartAndOpenDrawer(event, variantId) {
    event.preventDefault();
    
    const data = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };

    // Show loading state
    const button = event.target.closest('button');
    if (button) button.classList.add('loading');
  
    // First add the item to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      // Get cart drawer element
      const cartDrawer = document.querySelector('cart-drawer');
      
      // Fetch updated cart drawer content
      return fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          
          // Get the drawer inner content
          const drawerInner = cartDrawer.querySelector('.drawer__inner');
          const sourceInner = html.querySelector('.drawer__inner');
          
          if (drawerInner && sourceInner) {
            // Update the entire drawer inner content
            drawerInner.innerHTML = sourceInner.innerHTML;
          }

          // Update cart state
          cartDrawer.classList.remove('is-empty');
          
          // Remove empty content if it exists
          const emptyContent = cartDrawer.querySelector('.drawer__inner-empty');
          if (emptyContent) emptyContent.remove();

          // Open the drawer
          cartDrawer.open();

          // Dispatch events in sequence
          document.documentElement.dispatchEvent(
            new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                product: response,
                source: 'product-form'
              }
            })
          );

          // Use requestAnimationFrame to ensure DOM updates complete
          requestAnimationFrame(() => {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true
              })
            );

            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  source: 'product-form'
                }
              })
            );

            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: { source: 'product-form' }
              })
            );

            document.dispatchEvent(
              new CustomEvent('cart-drawer-items:updated', {
                bubbles: true
              })
            );
          });
        });
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(() => {
      // Remove loading state
      if (button) button.classList.remove('loading');
    });
}